module.exports = __webpack_public_path__ + "static/media/DownloadIcon.f556e33a.svg";